import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Fragment } from "react";

import Login from './pages/user/login';
import Trans from './pages/trans';
import AddTrans from './pages/trans/addTrans';
import Accumulative from './pages/trans/accumulative';
import Settlements from './pages/trans/settlements';
import UserAuthentication from './pages/trans/userAuthentication';
import InstallmentsFactor from './pages/installments_factor';
import ScrollToTop from './partials/ScrollToTop';
import BackDrop from './partials/BackDrop';
import Snackbar from './partials/snackbar';
import Header from './partials/header';
import Footer from './partials/footer';
import ImportModals from './partials/ImportModals';


const Root = () => {

    const { token } = useSelector(state => state.login);

    return (
        <Router>
            <Fragment>
                <ScrollToTop />
                <BackDrop />
                <Snackbar />
                <Header />
                
                <Routes> 
                    <Route path='/login' element={<Login />} />

                    { !!token ? 
                    <>
                    <Route path='/trans' element={<Trans />} />
                    <Route path='/trans/add' element={<AddTrans />} />
                    <Route path='/accumulative' element={<Accumulative />} />
                    <Route path='/settlements' element={<Settlements />} />
                    <Route path='/installments/factors' element={<InstallmentsFactor />} />
                    <Route path='/authentication' element={<UserAuthentication />} />

                    <Route path={"*"} element={ <Navigate replace to={ "/trans" }/> } />
                    </>
                    :
                    <>
                    <Route path='/trans' element={ <Navigate replace to={ "../login" }/> } />
                    <Route path='/trans/add' element={ <Navigate replace to={ "../login" }/> } />
                    <Route path='/accumulative' element={ <Navigate replace to={ "../login" }/> } />
                    <Route path='/settlements' element={ <Navigate replace to={ "../login" }/> } />
                    <Route path='/installments/factors' element={ <Navigate replace to={ "../login" }/> } />

                    <Route path={"*"} element={ <Navigate replace to={ "/login" }/> } />
                    </>
                    }
                    

                    
                </Routes>
                <ImportModals />
                <Footer />
            </Fragment>
        </Router>
    );

}

export default Root;
